module.exports = __webpack_public_path__ + "static/media/icon.0563c608.png";